import TextTruncate from "react-text-truncate"

type TextTruncateProps = {
  line: number
  element: string
  truncateText: string
  text: string
  textTruncateChild?: JSX.Element
  className?: string
}
// expmple of usage:
// const StyledTruncateText = styled(TruncateText)`
//   text-align: right;
//   font-size: 14px;
//   color: ${(p) => p.theme.colors.marbleGrey};
// `

// <StyledTruncateText
// line={2}
// element="span"
// truncateText="…"
// text={productData.short_description}
// />

const TruncateText = ({
  line,
  element,
  truncateText,
  text,
  textTruncateChild,
  className,
}: TextTruncateProps) => {
  return (
    <TextTruncate
      className={className}
      line={line}
      element={element}
      truncateText={truncateText}
      text={text}
      textTruncateChild={textTruncateChild}
      style={{
        display: "flex",
      }}
    />
  )
}

export default TruncateText

// in the future create this componnet for us:
// https://github.com/ShinyChang/react-text-truncate/blob/master/src/TextTruncate.js
